import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

/**
 * `npm run start:emulator` sets this: the app then talks to the local Firebase
 * emulator (fake test data on this computer) instead of the real database.
 */
export const USE_EMULATORS = process.env.REACT_APP_USE_EMULATORS === 'true';
const EMULATOR_PROJECT_ID = 'demo-shul-times';

const realConfig = {
  apiKey: "AIzaSyAQe4he9ONcegjYw4G-vOVeWJ1S6gUFgzg",
  authDomain: "shul-times-514d0.firebaseapp.com",
  projectId: "shul-times-514d0",
  storageBucket: "shul-times-514d0.firebasestorage.app",
  messagingSenderId: "164442947616",
  appId: "1:164442947616:web:ea4382b942f459edaefc45"
};

const firebaseConfig = USE_EMULATORS
  ? {
      ...realConfig,
      projectId: EMULATOR_PROJECT_ID,
      storageBucket: `${EMULATOR_PROJECT_ID}.appspot.com`,
    }
  : realConfig;

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'europe-west1');
export const storage = getStorage(app);

/** Emulator port; REACT_APP_EMULATOR_<NAME>_PORT overrides it (e.g. a second emulator set). */
function emulatorPort(name: string, fallback: number): number {
  return Number(process.env[`REACT_APP_EMULATOR_${name}_PORT`]) || fallback;
}

if (USE_EMULATORS) {
  connectFirestoreEmulator(db, 'localhost', emulatorPort('FIRESTORE', 8080));
  connectAuthEmulator(auth, `http://localhost:${emulatorPort('AUTH', 9099)}`, { disableWarnings: true });
  connectStorageEmulator(storage, 'localhost', emulatorPort('STORAGE', 9199));
  connectFunctionsEmulator(functions, 'localhost', emulatorPort('FUNCTIONS', 5001));
}
